<div class="px-4 pb-4">
    <mat-form-field class="w-full">
        <mat-label i18n>Insurance Category</mat-label>
        <mat-select [value]="currentCategoryId()" (selectionChange)="changeInsuranceCategory($event.value)">
            @for (c of insuranceCategories(); track c.id) {
                <mat-option [value]="c.id">{{ c.caption }}</mat-option>
            }
        </mat-select>
    </mat-form-field>
    @if (currentCategory()) {
        <div [innerHTML]="currentCategory().description"></div>
    }
</div>